// removed by extract-text-webpack-plugin
module.exports = {"Payment":"Payment__Payment___7nbE3","Title":"Payment__Title___2J7GQ","TitleClient":"Payment__TitleClient___3avtJ","InnerClient":"Payment__InnerClient___FnYbw","Row":"Payment__Row___1pkFC","Label":"Payment__Label___3Je16","LabelActive":"Payment__LabelActive___-spe-","Subtext":"Payment__Subtext___1Dcw1","Name":"Payment__Name___2hHEo","Image":"Payment__Image___SiqF7","PaymentPrint":"Payment__PaymentPrint___3psaV","Inner":"Payment__Inner___vgjuQ","RowGas":"Payment__RowGas___3q5Pf","Client":"Payment__Client___1dx9r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Main/Payment/Payment.scss
// module id = 1361
// module chunks = 0